/**
 * Versión de imágenes para cache-busting
 * Incrementa este número cuando actualices las imágenes de los apartamentos
 * para forzar a los navegadores a recargar las nuevas versiones
 */
export const IMAGE_VERSION = '2026-02-06-v123-fix-thumbnails';

/**
 * Agrega un parámetro de versión a una URL de imagen
 * Esto fuerza a los navegadores y a Next.js a recargar la imagen
 *
 * NOTA: Las URLs de Cloudinary ya vienen completas desde los JSONs (igual que videos)
 * Esta función solo añade cache-busting para cualquier URL (local o Cloudinary)
 */
export function versionedImageUrl(url: string): string {
  if (!url) return url;

  // Si la URL ya tiene query params, agregar con &
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${IMAGE_VERSION}`;
}

/**
 * Placeholder blur estático para LQIP (Low Quality Image Placeholder)
 *
 * OPTIMIZACIÓN: Usamos un placeholder base64 estático en lugar de
 * transformaciones dinámicas de Cloudinary para evitar:
 * - Requests adicionales a Cloudinary por cada imagen
 * - Costos de transformación y bandwidth
 *
 * Este es un gradiente suave gris-azulado que funciona bien con fotos de apartamentos
 */
const STATIC_BLUR_PLACEHOLDER = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAH4AABAAEAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDABQODxIPDRQSEBIXFRQdHx4eHRoaHSQtJSEkMjU1LS0yMi4qODY6KjE0PD44MjM4SEhGTklPV1dXODxNYWFNTkf/2wBDARUXFx4aHR4eHUdCMkJHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0dHR0f/wAARCAAIAAoDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAAAAME/8QAIBAAAgEDBAMAAAAAAAAAAAAAAQIRAAMEBRIhMUFRYf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AuapqN61mXbdu6yohAUAnAiYn3Wf+o6h7uP8AKlQf/9k=';

/**
 * Retorna un placeholder blur estático para usar con Next.js Image
 * Ya no hace requests a Cloudinary - usa un base64 inline
 */
export function getBlurDataUrl(_url: string): string {
  // Ignoramos la URL - siempre retornamos el placeholder estático
  // Esto elimina ~50% de los requests a Cloudinary
  return STATIC_BLUR_PLACEHOLDER;
}
